import { FormGroup } from '@angular/forms';

export const containsNumbersOnly = (str: string) => /^\d+$/.test(str);

export function base64ToArrayBuffer(base64) {
  const binaryString = window.atob(base64);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

export const camelCase = (str: string) => {
  return str?.charAt(0)?.toUpperCase() + str?.toLowerCase().substring(1);
};

export const convertToCamelCase = (str: string) => {
  return str?.charAt(0)?.toLowerCase() + str?.substring(1);
};

export const truncateEllipses = (str: string, maxLength: number, ellipsesString = '...'): string => {
  return str.length > maxLength ? str.slice(0, maxLength - 1) + ellipsesString : str;
};

/** Adds space between camel-cased words in string - e.g. "JoeJoe" becomes "Joe Joe". */
export const spaceOutCamelCase = (str: string): string => {
  return str?.match(/[A-Z][a-z]+/g)?.join(' ');
};

export const splitStringAndNumbers = (str: string): string => {
  return str?.match(/[A-Z]?[a-z]+|[0-9]+|[A-Z]+(?![a-z])/g)?.join(' ');
};

export const trimFormInput = (form: FormGroup, formControlName: string): void => {
  const control = form.get(formControlName);
  if (control && typeof control.value === 'string') {
    control.setValue(control.value.trim());
  }
};
